import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import * as css from './CreateEventPopup.css';

interface CreateEventPopupFooterProps {
    onCancel: () => void;
    onSaveDraft: () => void;
    // onSaveAndGoToSettings: () => void;
}

function CreateEventPopupFooter({onCancel, onSaveDraft}: CreateEventPopupFooterProps) {
    const {t} = useTranslation('subscriptions');

    return (
        <css.footer>
            <Button data-cy="assign-events-create-event-cancel-btn" variant="neutral" size="category" onClick={onCancel}>
                {t('cancel')}
            </Button>
            <css.footerButtons>
                <Button data-cy="assign-events-create-event-save-btn" variant="brand" size="category" onClick={onSaveDraft}>
                    {t('saveDraft')}
                </Button>
                {/* <Button variant="brand" size="category" onClick={onSaveAndGoToSettings}>
                    {t('saveGoToSettings')}
                </Button> */}
            </css.footerButtons>
        </css.footer>
    );
}

export default CreateEventPopupFooter;

